import React from 'react';
import { FacebookIcon, InstagramIcon, MessageCircleIcon, MusicIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-brand-navy pt-16 pb-8 text-white border-t border-white/10" data-id="element-119">
      <div className="container-custom" data-id="element-120">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-121">
          {/* Column 1: Contact */}
          <div className="flex flex-col gap-4" data-id="element-122">
            <h4 className="font-montserrat font-bold text-[16px] text-brand-gold mb-2 uppercase tracking-wider" data-id="element-123">
              Contact
            </h4>
            <div className="flex flex-col gap-3 text-[14px] text-white/80 leading-relaxed font-source" data-id="element-124">
              <p data-id="element-125">SC EDU FORMA STUDIO SRL, CUI: 52329180</p>
              <p data-id="element-126">Adresa: Mun. Ploiești, Str. Afinelor, Nr. 15, Jud. Prahova</p>
              <p data-id="element-127">Telefon: +40723580805</p>
              <a href="mailto:psiholog.ploiesti@yahoo.com" className="hover:text-white transition-colors" data-id="element-128">
                email: psiholog.ploiesti@yahoo.com
              </a>
            </div>
          </div>

          {/* Column 2: Legal */}
          <div className="flex flex-col gap-4" data-id="element-129">
            <h4 className="font-montserrat font-bold text-[16px] text-brand-gold mb-2 uppercase tracking-wider" data-id="element-130">
              Legal
            </h4>
            <ul className="flex flex-col gap-3" data-id="element-131">
              <li data-id="element-132">
                <a href="https://copilultau.ro/termeni-si-conditii" className="text-[14px] text-white/80 hover:text-white transition-colors uppercase font-source" data-id="element-133">
                  Termeni și Condiții
                </a>
              </li>
              <li data-id="element-134">
                <a href="https://copilultau.ro/politica-de-confidentialitate" className="text-[14px] text-white/80 hover:text-white transition-colors uppercase font-source" data-id="element-135">
                  Politica de Confidențialitate
                </a>
              </li>
              <li data-id="element-136">
                <a href="https://copilultau.ro/politica-cookies" className="text-[14px] text-white/80 hover:text-white transition-colors uppercase font-source" data-id="element-137">
                  Politica de Cookies
                </a>
              </li>
              <li data-id="element-138">
                <a href="#" className="text-[14px] text-white/80 hover:text-white transition-colors uppercase font-source" data-id="element-139">
                  ANPC
                </a>
              </li>
            </ul>
          </div>

          {/* Column 3: Social Media */}
          <div className="flex flex-col gap-4" data-id="element-140">
            <h4 className="font-montserrat font-bold text-[16px] text-brand-gold mb-2 uppercase tracking-wider" data-id="element-141">
              Social Media
            </h4>
            <ul className="flex flex-col gap-3" data-id="element-142">
              <li data-id="element-143">
                <a href="https://wa.me/40723580805" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-[14px] text-white/80 hover:text-white transition-colors font-source" data-id="element-144">
                  <MessageCircleIcon size={18} data-id="element-145" /> WhatsApp
                </a>
              </li>
              <li data-id="element-146">
                <a href="https://www.facebook.com/profile.php?id=100001552001084" className="flex items-center gap-3 text-[14px] text-white/80 hover:text-white transition-colors font-source" data-id="element-147">
                  <FacebookIcon size={18} data-id="element-148" /> Facebook
                </a>
              </li>
              <li data-id="element-149">
                <a href="https://www.instagram.com/cristina.geana/" className="flex items-center gap-3 text-[14px] text-white/80 hover:text-white transition-colors font-source" data-id="element-150">
                  <InstagramIcon size={18} data-id="element-151" /> Instagram
                </a>
              </li>
              <li data-id="element-152">
                <a href="https://www.tiktok.com/@cristinageanapsi" className="flex items-center gap-3 text-[14px] text-white/80 hover:text-white transition-colors font-source" data-id="element-153">
                  <MusicIcon size={18} data-id="element-154" /> Tiktok
                </a>
              </li>
            </ul>
          </div>

          {/* Column 4: Badges */}
          <div className="flex flex-col gap-4" data-id="element-155">
            <a href="https://anpc.ro/ce-este-sal/" target="_blank" rel="noopener noreferrer" className="block w-full max-w-[250px] bg-white rounded-md overflow-hidden" data-id="element-156">
              <img src="https://cdn.magicpatterns.com/uploads/fJVqkGQXGwcmxRpZkHAdNH/ANPC.webp" alt="ANPC - Soluționarea Alternativă a Litigiilor" className="w-full h-auto" data-id="element-157" />
            </a>
            <a href="https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home2.show&lng=RO" target="_blank" rel="noopener noreferrer" className="block w-full max-w-[250px] bg-white rounded-md overflow-hidden" data-id="element-158">
              <img src="https://cdn.magicpatterns.com/uploads/qLFoURYbFj66rf7T7dnGr7/SAL.jpg" alt="Soluționarea Online a Litigiilor" className="w-full h-auto" data-id="element-159" />
            </a>
          </div>
        </div>

        {/* Copyright line */}
        <div className="pt-8 border-t border-white/15 text-center" data-id="element-160">
          <p className="font-source text-[13px] text-white/80" data-id="element-161">
            © Copyright 2026.{' '}
            <span className="font-bold text-white" data-id="element-162">
              SC EDU FORMA STUDIO SRL
            </span>
            . Toate drepturile rezervate.
          </p>
        </div>
      </div>
    </footer>;
}